import React, { createContext, useState, useContext, useEffect } from "react";
import { authAPI } from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const fetchUserInfo = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      setIsAuthenticated(false);
      return null;
    }

    try {
      const response = await authAPI.getUserInfo();
      if (response && response.user) {
        setUser(response.user);
        setIsAuthenticated(true);
        return response.user;
      } else {
        setUser(null);
        setIsAuthenticated(false);
        return null;
      }
    } catch (error) {
      console.error("사용자 정보 조회 실패:", error);
      setUser(null);
      setIsAuthenticated(false);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const login = async (data) => {
    console.log("AuthContext - 로그인 시작. 데이터:", {
      ...data,
      token: data.token ? data.token.substring(0, 10) + "..." : "none",
    });

    try {
      if (!data || !data.token) {
        throw new Error("토큰이 없습니다.");
      }

      // 토큰 저장 - 중요: 이 토큰은 서버의 sessions 테이블에 저장된 토큰과 정확히 일치해야 함
      localStorage.setItem("token", data.token);
      console.log(
        "localStorage에 토큰 저장:",
        data.token.substring(0, 10) + "..."
      );

      // 사용자 정보 설정
      const userData = data.user || {};
      setUser({
        id: userData.id,
        email: userData.email,
        name: userData.name,
        isAuthenticated: true,
      });

      // 로그인 상태로 설정
      setIsAuthenticated(true);
      console.log("로그인 완료: 인증 상태 =", true);

      return true;
    } catch (error) {
      console.error("AuthContext - 로그인 오류:", error);
      setIsAuthenticated(false);
      setUser(null);
      localStorage.removeItem("token");
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setIsAuthenticated(false);
    setLoading(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        fetchUserInfo,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
